import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';
import { HasBeenPaid } from '../assets';
import {
  Wrapper,
  Header,
  Container,
  Img,
  Title,
  Description,
  BackToHome,
  Supporter,
} from './index.view';

type Props = {
  redirectUrl: string;
};

const ErrorHasBeenPaid = ({ redirectUrl }: Props) => {
  const { t } = useTranslation();
  const contactEmail = () => <Supporter href="mailto:support@fanz.io">support@fanz.io.</Supporter>;
  const homeUrl = localStorage?.getItem('homeUrl') ?? 'https://www.fanz.io/';
  return (
    <Wrapper>
      <Header>
        <Icon name="logo" />
      </Header>
      <Container maxWidth="md">
        <Img src={HasBeenPaid} alt="hasBeenPaid" />

        <Title>{t('paymentHasBeenPaid')}</Title>

        <Description>
          {t('paymentHasBeenPaidDescription')}
          {contactEmail()}
        </Description>
        <BackToHome onClick={() => (window.location.href = homeUrl)}>
          <span>{t('bringMeHome')}</span>
        </BackToHome>
      </Container>
    </Wrapper>
  );
};

export default ErrorHasBeenPaid;
